// NOTE: update public/i18n you update this enum
export const LocaleKey = {
  EN_US: 'en-US',
  FR_FR: 'fr-FR',
};

export const defaultLocale = LocaleKey.EN_US;

export const availableLocales = Object.values(LocaleKey);
